export default __webpack_public_path__ + "static/media/plus.25203093.svg";